import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { CreateSignalModalProps } from "app/pages/sales-intelligence/sub-modules/signals/components/modals/CreateSignalModal/CreateSignalModal";
import CreateSignalModal from "app/pages/sales-intelligence/sub-modules/signals/components/modals/CreateSignalModal/CreateSignalModal";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

type Props = CreateSignalModalProps & { selectedSignalCreateType: SignalType };

const CreateSignalModalTracked = (props: Props) => {
    const { selectedSignalCreateType, ...modalProps } = props;

    function handleReturnTrackedClick() {
        trackingService.management.trackCreateReturnSignalEvent(selectedSignalCreateType);
        props.onReturn();
    }

    function handleCloseTrackedClick() {
        trackingService.management.trackCreateCancelSignalEvent(selectedSignalCreateType);
        props.onClose();
    }

    return (
        <CreateSignalModal
            {...modalProps}
            onReturn={handleReturnTrackedClick}
            onClose={handleCloseTrackedClick}
        >
            {props.children}
        </CreateSignalModal>
    );
};

export default CreateSignalModalTracked;
